import { useSelector } from "react-redux";
import { hasAnyRole } from "../utils/roles";
import NoAccess from "./NoAccess";

export default function RoleGuard({ allowedRoles, children }) {
  const userRoles = useSelector((state) => state.globalData.userRoles);

  // Roles haven't loaded yet, don't block rendering / cause a flash redirect.
  if (userRoles === null) return null;

  if (!hasAnyRole(userRoles, allowedRoles)) {
    return <NoAccess />;
  }

  return children;
}
